<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="16">
						<el-form-item label="名称" prop="name">
							<el-input v-model="formParameter.name" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="状态" prop="state">
							<select-option-dictionary placeholder="请选择状态" v-model="formParameter.state"
								dkey="tst-state"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="所属产品" prop="productid">
							<el-select v-model="formParameter.productid" placeholder="选择所属产品"
								@change="isUserChangeProduct = true">
								<el-option v-for="(itm, index) in inProducts" :key="index" :label="itm.name"
									:value="itm.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="发布人" prop="publisher">
							<el-select v-model="publisher" placeholder="选择发布人">
								<el-option v-for="(itm, index) in inPublisher" :key="index" :label="itm.name"
									:value="itm.usrid">
								</el-option>
							</el-select></el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="执行人" prop="executor">
							<el-select v-model="executor" placeholder="选择执行人">
								<el-option v-for="(itm, index) in inPublisher" :key="index" :label="itm.name"
									:value="itm.usrid">
								</el-option>
							</el-select></el-form-item>
					</el-col>
				</el-row>

				<!-- 字符含义 - 多行可编辑 char + mean -->
				<el-row>
					<el-col :span="12">
						<el-form-item label="字符含义">
							<div class="char-mean-header"
								style="display: flex; gap: 10px; margin-bottom: 8px; font-weight: bold;">
								<div style="width: 120px;">char</div>
								<div style="width: 200px;">mean</div>
								<div style="width: 80px;">操作</div>
							</div>

							<div v-for="(item, idx) in charMeanList" :key="idx"
								style="display: flex; gap: 10px; align-items: center; margin-bottom: 8px;">
								<el-input v-model="item.char" placeholder="字符" style="width: 120px"
									autocomplete="off" />
								<el-input v-model="item.mean" placeholder="含义" style="width: 200px"
									autocomplete="off" />
								<el-button type="text" danger @click="charMeanList.splice(idx, 1)">删除</el-button>
							</div>

							<el-button type="primary" plain icon="el-icon-plus" @click="addCharMeanRow">添加一行</el-button>
						</el-form-item>
					</el-col>
			 	</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="开始时间" prop="createTime">
							<el-date-picker v-model="formParameter.createTime" type="datetime" placeholder="选择开始时间"
								value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束时间" prop="endTime">
							<el-date-picker v-model="formParameter.endTime" type="datetime" placeholder="选择结束时间"
								value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="方案步骤" prop="remarks">
							<wang-edit :isupdt="isUpdtWedit" v-model="formParameter.remarks"></wang-edit>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="'添加' != title">
					<el-col :span="24">
						<el-form-item label="结论" prop="conclusion">
							<wang-edit :isupdt="isUpdtWedit" v-model="formParameter.conclusion"></wang-edit>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/product/tst/testplan/testplan.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import wangEdit from '@/components/wangEdit/wangEdit.vue';

export default {
	name: 'edit',
	components: {
		popup, selectOptionDictionary, wangEdit
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			inProducts: [],
			inPublisher: [],
			isUserChangeProduct: false,
			publisher: '',
			executor: '',
			isUpdtWedit: false,
			title: '',
			charMeanList: [], // 字符含义数组
			rules: {
				name: [
					{ validator: this.$validate.required, trigger: 'blur' },
					{ validator: this.$validate.length, max: 255, trigger: 'blur' }
				],
				productid: [
					{ validator: this.$validate.required, trigger: 'blur' },
					{ validator: this.$validate.length, max: 32, trigger: 'blur' }
				]
			}
		};
	},

	watch: {
		"formParameter.productid"(newVal) {
			if (!newVal) {
				this.inPublisher = [];
				this.publisher = "";
				this.executor = "";
				return;
			}
			if (this.isUserChangeProduct) {
				this.getPublisher(true);
			} else {
				this.getPublisher(false);
			}
			this.isUserChangeProduct = false;
		}
	},

	methods: {
		// 添加字符含义行
		addCharMeanRow() {
			this.charMeanList.push({ char: '', mean: '' });
		},

		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.title = title
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},

		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},

		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;

				// 数组转 JSON 字符串
				this.formParameter.charMean = JSON.stringify(this.charMeanList);

				this.formParameter.publisher = this.publisher
				this.formParameter.executor = this.executor
				let parameter = this.$utils.merger(this.formParameter);

				if (!this.parameter.id) {
					api.saveApi(parameter, res => {
						this.$utils.msg.success(res.msg);
						this.confirmLoading = false;
						this.close();
						this.$parent.list();
					}, res => {
						this.$utils.msg.warning(res.msg);
						this.confirmLoading = false;
					});
				} else {
					api.updateApi(parameter, res => {
						this.$utils.msg.success(res.msg);
						this.confirmLoading = false;
						this.close();
						this.$parent.list();
					}, res => {
						this.$utils.msg.warning(res.msg);
						this.confirmLoading = false;
					});
				}
			});
		},

		getPublisher(autoSelectFirst) {
			let pid = this.formParameter.productid;
			if (!pid) return;
			this.inPublisher = [];
			api.listPublishersApi({ id: pid }, res => {
				this.inPublisher = res.data;
				if (autoSelectFirst && this.inPublisher.length) {
					this.publisher = this.inPublisher[0].usrid;
					this.executor = this.inPublisher[0].usrid;
				}
			}, err => console.log("获取发布人失败", err));
		},

		init() {
			this.popupLoading = true;
			this.confirmLoading = false;
			this.formParameter = {};
			this.charMeanList = []; // 清空
			this.inPublisher = [];
			this.$refs.form.clearValidate();

			api.listProductsApi({}, res => {
				this.inProducts = res.data;
			}, err => console.log("❌ 失败", err));

			if (this.parameter.id) {
				let parameter = { id: this.parameter.id };
				api.toupdtApi(parameter, res => {
					if (res.data) {
						this.formParameter = res.data;

						// 解析回显字符含义
						try {
							this.charMeanList = JSON.parse(this.formParameter.charMean || '[]');
						} catch (e) {
							this.charMeanList = [];
						}

						this.isUpdtWedit = true;
						setTimeout(() => this.isUpdtWedit = false, 45);
						this.getPublisher(false);
						this.publisher = this.formParameter.publisher;
						this.executor = this.formParameter.executor;
						this.popupLoading = false;
					}
				});
			} else {
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>